import { Box, HStack, Button, Icon } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/services/state/store";
import {
  setIsAnalystView,
  setIsConnect,
  setSelectedtheme,
} from "../../services/state/Process-modular/processModular";
import { IconType } from "react-icons";
import { IoMdSave } from "react-icons/io";
import { IoFolderOpenOutline } from "react-icons/io5";
import { BiPointer, BiSolidPointer } from "react-icons/bi";
import { FaRegCirclePlay } from "react-icons/fa6";
import { MdDarkMode, MdOutlineDarkMode } from "react-icons/md";
import React from "react";

interface IToolBarItem {
  id: string;
  icon: IconType;
  name: string;
  onSelect?: () => void;
}

interface ToolBarProps {
  onAdd: () => void;
  onSaveToDB: () => Promise<void>;
  onFileRestore: (event?: React.ChangeEvent<HTMLInputElement>) => void;
  checkNodes: () => void;
  handleCopyNode: () => void;
  handlePasteNoded: () => void;
  runProcess: () => void;
}

export const ToolBarIcons = ({
  onAdd,
  onSaveToDB,
  onFileRestore,
  checkNodes,
  handleCopyNode,
  handlePasteNoded,
  runProcess,
}: ToolBarProps) => {
  const dispatch: AppDispatch = useDispatch();

  const connect = useSelector(
    (state: RootState) => state.processModeler.isConnect
  );

  const isAnalystView = useSelector(
    (state: RootState) => state.processModeler.isAnalystView
  );

  const theme = useSelector(
    (state: RootState) => state.processModeler.selectedTheme
  );

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    dispatch(setSelectedtheme(newTheme));
  };

  const toggleConnect = () => {
    dispatch(setIsConnect(!connect));
  };

  const toolBarItems: IToolBarItem[] = [
    {
      id: "Save",
      icon: IoMdSave,
      name: "Save",
      onSelect: onSaveToDB,
    },
    {
      id: "Open",
      icon: IoFolderOpenOutline,
      name: "Open",
      onSelect: onFileRestore,
    },
    {
      id: "ConnectToggle",
      icon: connect ? BiSolidPointer : BiPointer,
      name: connect ? "Disconnect" : "Connect",
      onSelect: toggleConnect,
    },
    {
      id: "Run",
      icon: FaRegCirclePlay,
      name: "Run",
      onSelect: runProcess,
    },
  ];

  return (
    <Box
      width={"100%"}
      border={"1px"}
      bg="rgba(255, 255, 255, 0.05)"
      backdropFilter="blur(20px)"
      borderWidth={"1px"}
      borderColor="rgba(255, 255, 255, 0.1)"
      // borderRadius="12px"
      display={"flex"}
      flexDirection={"row"}
      px={2}
      py={1}
      color="white"
      alignItems="center"
      justifyContent="space-between"
      minHeight="40px"
    >
      <HStack spacing={4} width={"100%"} p={1} alignItems="center">
        {toolBarItems.map((toolbar) => (
          <Box
            key={toolbar.id}
            display="flex"
            alignItems="center"
            onClick={toolbar.onSelect}
            cursor="pointer"
            _hover={{ color: "brand.400" }}
            color="white"
            p={2}
            borderRadius="md"
            transition="all 0.2s ease"
          >
            <Icon
              as={toolbar.icon as React.ElementType}
              color="white"
              boxSize="18px"
            />
          </Box>
        ))}

        {/* Toggle Theme Button */}
        <Box
          display="flex"
          alignItems="center"
          onClick={toggleTheme}
          cursor="pointer"
          _hover={{ color: "brand.400" }}
          color="white"
          p={2}
          borderRadius="md"
          transition="all 0.2s ease"
        >
          <Icon
            as={
              theme === "light"
                ? (MdOutlineDarkMode as React.ElementType)
                : (MdDarkMode as React.ElementType)
            }
            color="white"
            boxSize="18px"
          />
        </Box>
      </HStack>

      <HStack p={1} spacing={2} alignItems="center">
        <Button
          size={"xs"}
          bgColor={isAnalystView ? "#9500ff" : "rgba(255, 255, 255, 0.1)"}
          color="white"
          borderColor={isAnalystView ? "#9500ff" : "rgba(255, 255, 255, 0.3)"}
          variant={isAnalystView ? "solid" : "outline"}
          onClick={() => dispatch(setIsAnalystView(true))}
          _hover={{
            bgColor: isAnalystView ? "#8B5CF6" : "rgba(255, 255, 255, 0.2)",
            borderColor: "brand.400",
          }}
        >
          ANALYST VIEW
        </Button>
        <Button
          size={"xs"}
          bgColor={!isAnalystView ? "#9500ff" : "rgba(255, 255, 255, 0.1)"}
          color="white"
          borderColor={!isAnalystView ? "#9500ff" : "rgba(255, 255, 255, 0.3)"}
          variant={!isAnalystView ? "solid" : "outline"}
          onClick={() => dispatch(setIsAnalystView(false))}
          _hover={{
            bgColor: !isAnalystView ? "#8B5CF6" : "rgba(255, 255, 255, 0.2)",
            borderColor: "brand.400",
          }}
        >
          DESIGNER VIEW
        </Button>
      </HStack>
    </Box>
  );
};
